import { Select, Steps, Checkbox } from "antd";
import React from "react";
import { MinusCircleOutlined } from "@ant-design/icons";
const { Step } = Steps;
const { Option } = Select;

const HirarchicalApproval = ({
  selectedRoles,
  approvalData,
  setApprovalData,
  handleList,
  editMode,
  setSelectedRoles,
  rolesData,
}) => {
  const handleInputs = (val, key, level, value) => {
    let idx = approvalData.findIndex((obj) => obj.level === level);
    approvalData[idx] = { ...value, ...approvalData[idx], [key]: val };
    setApprovalData([...approvalData]);
    if (key === "role_id") {
      setSelectedRoles([...selectedRoles, val]);
    }
  };

  const stepRender = (item) => (
    <>
      {item.level === 0 || item.level === 1 || item.role_name ? (
        <div className="disabledDiv">{item.role_name}</div>
      ) : (
        <Select
          disabled={!editMode}
          placeholder="Select Role"
          className="select-role"
          onChange={(val) => {
            handleInputs(
              val,
              "role_id",
              item.level,
              rolesData?.find((ele) => ele.id === val)
            );
          }}
          value={item.role_id}
        >
          {rolesData &&
            rolesData
              ?.filter(
                (ele) =>
                  ele.role_name !== "Admin" &&
                  !approvalData?.map((ele) => ele.role_id)?.includes(ele.id)
              )
              .map(({ id, role_name }) => (
                <Option key={id} value={id}>
                  {role_name}
                </Option>
              ))}
        </Select>
      )}

      {item.level !== 0 ? (
        <div className="approvalsCheckbox">
          {/* <Checkbox
                  defaultChecked={item.can_reimburse}
                  onChange={(e) => handleInputs(e.target.checked, 'can_reimburse', item.level)}
                >Can Reimburse</Checkbox> */}
          <Checkbox
            disabled={!editMode}
            defaultChecked={item.can_approve_or_reject}
            onChange={(e) =>
              handleInputs(
                e.target.checked,
                "can_approve_or_reject",
                item.level,
                rolesData?.find((ele) => ele.id === item.role_id)
              )
            }
          >
            Can perform action on all advances
          </Checkbox>
        </div>
      ) : null}

      {item.level !== 0 && item.level !== 1 && editMode ? (
        <MinusCircleOutlined
          className="minusButton inlineItem mtHalf cursor ml2"
          onClick={() => handleList("remove", item.level)}
        />
      ) : null}
    </>
  );

  return (
    <Steps
      direction="vertical"
      size="small"
      current={approvalData.length + 1 || 100}
    >
      {approvalData &&
        approvalData.map((item, index) => (
          <Step
            key={item.id}
            title={stepRender(item)}
            icon={<div className="stepsNumber">{index + 1}</div>}
          />
        ))}
    </Steps>
  );
};

export default HirarchicalApproval;
